import { useInAppNavigate } from '@Alias/hooks';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getIsUserLoggedIn } from '../../redux/selectors/config';
import { MY_TV, SIGNUP_NESTED } from '../../utils/router';
import useRedirectToPlayer from '../router/use-redirect-to-player';

/** KU
 *
 * Returns a handler, {@link handleStartSignup}, which redirects a logged-in
 * user to `/player` (via {@link handleRedirectToPlayer}) and a logged out user
 * to {@link SIGNUP_NESTED}. */
export default function useStartSignup() {
  const isUserLoggedIn = useSelector(getIsUserLoggedIn);
  const navigate = useInAppNavigate();

  const { handleRedirectToPlayer } = useRedirectToPlayer();

  const handleStartSignup = useCallback(() => {
    // KU – need latest value of this field
    if (isUserLoggedIn) {
      handleRedirectToPlayer(MY_TV);
    } else {
      navigate(SIGNUP_NESTED);
    }
  }, []);

  return { handleStartSignup };
}
